import { TRUE_STRING } from '@/common/constants';

export enum BalanceReminderPayloadKey {
  thirtyDays = 'thirty_days_before_banner',
}

const watchedKey = 'BalanceReminderWatched';

const balanceReminderSessionStorage = {
  setWatched: () => sessionStorage.setItem(watchedKey, TRUE_STRING),
  getWatched: () => sessionStorage.getItem(watchedKey),

  setThirtyDays: () => sessionStorage.setItem(BalanceReminderPayloadKey.thirtyDays, TRUE_STRING),

  getThirtyDays: (): boolean => Boolean(sessionStorage.getItem(BalanceReminderPayloadKey.thirtyDays)),

  clear: () => {
    sessionStorage.removeItem(watchedKey);
    sessionStorage.removeItem(BalanceReminderPayloadKey.thirtyDays);
  },
};

export default balanceReminderSessionStorage;
